<template>
    <div id="personal-albums" :class="{'mt-4': $route.name !== 'my-photos'}">
        <div v-if="customerItems">
            <div id="personal-albums-items" class="row" v-if="customerItems.length && isIssetCutomerAlbums">
                <div id="personal-albums-item-form" class="col-md-4" v-if="$route.name === 'my-photos'">
                    <div class="hidden-album-box hidden-album-box--card hidden-album-box--no-bg">
                        <div class="hidden-album-box-title">{{ $t('private_gallery') }}</div>
                        <div class="hidden-album-box-text">{{ $t('descriptions.personal_albums') }}</div>
                        <div v-if="coreParams.shop_design && coreParams.shop_design.info_text" class="hidden-album-box-text">
                            <hr><div v-html="coreParams.shop_design.info_text"></div>
                        </div>
                        <hidden-album-form/>
                    </div>
                </div>
                <div :id="`personal-albums-item-${i + 1}`" class="col-md-4" v-for="(item, i) in customerItems" :key="i">
                    <div class="bk-card-wrap">
                        <a href="#" @click.prevent="$router.push(i18nLink(`album/gallery/${item.hash}${item.tag_url ? `/tag/${item.tag_url}` : ''}`))" class="bk-card">
                            <span class="bk-card-img bk-card-img--contain"
                                  :style="getThumbnail(item) ? `background-image: url(${getThumbnail(item)})`: ''">
                                <img v-if="!getThumbnail(item)" :src="require(`@/templates/${coreParams.theme_name}/assets/no-preview.jpg`)" :alt="item.title">
                            </span>
                            <span class="bk-card-body">
                                <span class="bk-card-title d-block">
                                    {{ item.title ? item.title : $t('no_name') }}{{ item.tag_url ? ` [${_.first(item.tag_url.split('-'))}]` : '' }}
                                </span>
                                <span class="bk-card-text d-block">
                                    {{ $tc('n_photos_2', item.total_pictures, {amount_total_photos: item.total_pictures}) }}
                                </span>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
            <div v-else id="hidden-album-box" class="hidden-album-box hidden-album-box--no-bg">
                <div class="hidden-album-box-title">{{ $t('private_gallery') }}</div>
                <div class="row">
                    <div class="col-md-7">
                        <div class="hidden-album-box-text">{{ $t('descriptions.personal_albums') }}</div>
                        <div v-if="coreParams.shop_design && coreParams.shop_design.info_text" class="hidden-album-box-text">
                            <hr><div v-html="coreParams.shop_design.info_text"></div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <hidden-album-form :label="!isMobile" position="top"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .my-photos {

        .hidden-album-box {
            border: 2px dashed #dcdcdc;
        }

        > div {
            margin: 0 !important;
        }
    }
</style>

<script>
  import HiddenAlbumForm from '../HiddenAlbumForm.vue';

  import personalAlbums from 'src/mixins/personalAlbumsComponent';

  export default {
    mixins: [personalAlbums],
    components: {
      HiddenAlbumForm,
    }
  };
</script>
